const AnimalDetailPage = (
    {
        animalData,
        handleGoBack
    }
) => {
    
    const renderData = () => (
        <div className="m-5">
            <div className="text-center pb-3">
                <h1>Detail dari <span className="fw-bold text-primary">{animalData.name}</span></h1>
            </div>
            <div id="MyDiv" className="rubberBand gambar-wrapper d-flex flex-column justify-content-start align-items-center">
                <img className="gambar" src={animalData.imageLink} alt={animalData.name} style={{ width: '300px', height:'300px' }} />
                <div className="d-flex flex-column justify-content-start align-items-start">
                    <p className="fw-bold">Nama: <span>{animalData.name}</span></p>
                    <p className="fw-bold">Habitat : <span>{animalData.habitat}</span></p>
                    <p className="fw-bold">Nama Latin : <span>{animalData.latinName}</span></p>
                </div>
                <button className="btn btn-success mt-4" onClick={handleGoBack}>Back</button>
            </div>
        </div>
    )

    return(
        <div>
            {
                animalData 
                ?
                renderData()
                :
                <div>Data Kosong</div>
            }

        </div>
    )
}

export default AnimalDetailPage; 